<template>
  <div class="d-md-flex">
    <div class="row col-md-6 mx-0 px-0">
      <img src="@/assets/img/academica.jpg" text="imagen" class="img-fluid" />
    </div>

    <div class="row col-md align-items-start mt-3 mt-md-0 mx-0 px-0">
      <ul class="kpis-ca col-md ml-md-3 mx-0 px-0">
        <li class="flex-grow-1">
          <div>
            Nº JC totales
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.numeroJCTotales)}}</span>
          </div>
        </li>
        <li class="flex-grow-1">
          <div>
            Nº JCE totales
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.numeroJCETotales)}}</span>
          </div>
        </li>
        <li class="flex-grow-1" v-if="tipoFicha==='UNIVERSIDAD'">
          <div>
            Nº de publicaciones SCielo (no ISI)
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.numeroPublicacionesSCIELO)}}</span>
          </div>
        </li>
        <li class="flex-grow-1" v-if="tipoFicha==='UNIVERSIDAD'">
          <div>
            Nº de publicaciones WOS (ex ISI)
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.numeroPublicacionesWOS)}}</span>
          </div>
        </li>
        <li class="flex-grow-1" v-if="tipoFicha==='UNIVERSIDAD'">
          <div>
            Nº de proyectos FONDECYT
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.numeroProyectorFONDECYT)}}</span>
          </div>
        </li>
        <li class="flex-grow-1">
          <div>
            Promedio de alumnos por JCE
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.promedioAlumnosPorJCE)}}</span>
          </div>
        </li>
        <li class="flex-grow-1">
          <div>
            Promedio de alumnos por JC
            <span
              class="float-right text-nowrap"
            >= {{formatoNumerico(indicadores.promedioAlumnosPorJC)}}</span>
          </div>
        </li>
      </ul>
      <div class="col col-md-12 d-block pl-4 pr-4 ml-1 mr-auto">
        <p class="text-muted">
          <small>
            <strong>JC</strong>: Jornadas Completas  | 
            <strong>JCE</strong>: Jornadas Completas Equivalentes
          </small>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import FormatoMonetario from "@/utils/FormatoMonetario.js";

export default {
  name: "IndicadoresCalidad",
  props: {
    indicadores: {
      type: Object
    },
    tipoFicha: {
      type: String
    }
  },
  methods: {
    formatoNumerico(val) {
      return FormatoMonetario.getFormatoNumerico(val);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/IndicadoresCalidad.vue